import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { environment } from '@rocksoft/environment';
import { DeviceActiveSyncsStoreSelectors } from '../../sub-features/device-sync/device-active-syncs-store';
import { ActiveDeviceSyncsProgressBarComponent } from './active-device-syncs-progress-bar.component';

@Component({
  selector: 'era-active-device-syncs-progress-bar',
  templateUrl: './active-device-syncs-progress-bar.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ActiveDeviceSyncsProgressBarComponent],
})
export class ActiveDeviceSyncsProgressBarContainerComponent {
  private readonly store = inject(Store);

  public readonly maximumActiveDeviceSyncs = environment.maximumSyncLoad;
  public readonly currentActiveDeviceSyncs = this.store.selectSignal(
    DeviceActiveSyncsStoreSelectors.selectCurrentActiveDeviceSyncs
  );
}
